var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqNewSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_781_9817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 20.7286C16.8208 20.7286 20.7286 16.8207 20.7286 12C20.7286 7.17934 16.8208 3.27142 12.0001 3.27142C7.1794 3.27142 3.27148 7.17934 3.27148 12C3.27148 16.8207 7.1794 20.7286 12.0001 20.7286Z",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65002 9.64949C9.65002 9.1847 9.78798 8.73036 10.0464 8.3439C10.3049 7.95745 10.6722 7.65625 11.102 7.47838C11.5318 7.30051 12.0048 7.25398 12.461 7.34465C12.9173 7.43532 13.3364 7.65914 13.6654 7.9878C13.9943 8.31645 14.2183 8.73518 14.3091 9.19103C14.3999 9.64689 14.3533 10.1194 14.1753 10.5488C13.9972 10.9782 13.6957 11.3452 13.3089 11.6034C12.9221 11.8616 12.4674 11.9995 12.0022 11.9995V13.5661",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.6443C11.8146 16.6443 11.6643 16.494 11.6643 16.3086C11.6643 16.1231 11.8146 15.9728 12 15.9728",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.6443C12.1854 16.6443 12.3357 16.494 12.3357 16.3086C12.3357 16.1231 12.1854 15.9728 12 15.9728",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_781_9817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqNewSelected);
export default __webpack_public_path__ + "static/media/FAQNewSelected.00a8fdfd4ef9de8be8472dded735484c.svg";
export { ForwardRef as ReactComponent };